import { useCallback, useEffect, useState } from "react";
import { AGREEMENT_INPUT_FORM, DOCU_SIGN_STATUS, STATUS } from "../../utils/constants/GlobalFormConstants";
import GridContainer from "../common/grid/GridContainer";
import GridItem from "../common/grid/GridItem";
import TextInput from "../common/textInput/TextInput";
import Typo from "../common/typo/Typo";
import { COLOR_RED, FORM_FONT_STYLE, VALIDATIONS } from "../../utils/constants/GlobalConstants";


const AgreementInput = (props) => {
  const [data, setData] = useState(props.data);
  const [signStatus,setSignStatus]= useState("");
  const [remarks,setRemarks]= useState("");
  const [signDate,setSignDate]=useState("");
  const [value,setValue]=useState("")

  const validateField = (key, value) => {
    const newErrors = { ...props?.errorMessages };
    if (!value) {
      delete newErrors[key];
    } else if (newErrors && newErrors?.installerBusinessName && key === 'installerBusinessName' && value.length > 60) {
      newErrors.installerBusinessName = VALIDATIONS.INSTALLER_NAME_LENGTH;
    } else {
      delete newErrors[key];
    }
    props?.setErrorMessages(newErrors);
  };
  const getApprovedStatus =useCallback(()=>{
    let res;
    if(props?.fromInstaller){
      res = props?.debiDetails?.docusignDetails?.filter(o => o.signerEmail ===  props?.debiDetails?.debis[0]?.installerEmail);
    }
    else{
      res = props?.debiDetails?.docusignDetails?.filter(o => o.signerEmail ===  props?.debiDetails?.debis[0]?.salesRepEmail);
    }
    let finalStatus;
    let signDate;
    if(res[0]?.mailStatus === DOCU_SIGN_STATUS.MAIL_TRIGGERED){
     finalStatus = DOCU_SIGN_STATUS.MAIL_TRIGGERED_VALUE
    } else if(res[0]?.mailStatus === DOCU_SIGN_STATUS.COMPLETED){
       finalStatus= DOCU_SIGN_STATUS.COMPLETED_VALUE;
       signDate = res[0]?.lastUpdatedTs;
    } else if(res[0]?.mailStatus === DOCU_SIGN_STATUS.CREATED){
      finalStatus = props?.fromInstaller ? DOCU_SIGN_STATUS.CREATED_VALUE_INSTALLER : DOCU_SIGN_STATUS.CREATED_VALUE_SALES
    } else if(res[0]?.mailStatus === DOCU_SIGN_STATUS.DECLINED){
      finalStatus = DOCU_SIGN_STATUS.DECLINED_VALUE
    } else if(res[0]?.mailStatus === DOCU_SIGN_STATUS.SENT){
      finalStatus = DOCU_SIGN_STATUS.SENT_VALUE
    }
    let remarks= res[0]?.remarks;
    return {finalStatus,remarks,signDate}
  },[props?.debiDetails?.debis,props?.debiDetails?.docusignDetails,props?.fromInstaller])
  useEffect(() => {
    setData(props.data);
    setValue(props?.remainingFields?.installerBusinessName)
  }, [props]);
  useEffect(()=>{
    if(props?.debiDetails){
      let obj= getApprovedStatus();
      setSignStatus(obj?.finalStatus);
      setRemarks(obj?.remarks);
      setSignDate(obj?.signDate)
    }
  },[props.debiDetails,getApprovedStatus])
 const handleChange =(e)=>{
  setValue(e.target.value);
  validateField(data.key,e.target.value);
  props.onChange(data.key,e.target.value)
 }
  return (
    <div className="form-layout">
      <GridContainer>
        <GridItem xs={12} sm={4} lg={4} md={4} xl={4}>
          {data && props.installerName ? (
            <><TextInput label={AGREEMENT_INPUT_FORM.label} 
            disabled={!(props?.username === props?.debiDetails?.debis[0]?.createdBy)  ||
               (props?.debiDetails?.debis[0]?.statusReason === STATUS.OPEN) ||
              (props?.debiDetails?.debis[0]?.statusReason === STATUS.CLOSED) || 
              !(props?.debiDetails?.docusignDetails && props?.debiDetails?.docusignDetails?.length === 0)
              }
            
            testid ="input" required={true} onChange={handleChange} value ={value}/>
            </>
          ) : (
            <>
              <Typo
                variant="body2"
                text={data.label}
                color="secondary"
                sx={FORM_FONT_STYLE}
              />
              <Typo variant="body2" text={props.username} color="secondary" />
            </>
          )}
        </GridItem>
        <GridItem xs={12} sm={8} lg={8} md={8} xl={8}>
        {props?.editClicked ? "" :  
        <div className="flex-container flex-center">
          {signStatus} {signDate && "on "+signDate} {remarks && remarks !== " " && "with remarks as "+remarks+"."}
          </div>
            }
         
        </GridItem>
        {props?.errorMessages?.installerBusinessName && (
              <div style={COLOR_RED}>
                {props?.errorMessages?.installerBusinessName}
              </div>
            )}
      </GridContainer>
    </div>
  );
};

export default AgreementInput;
